<template>
    <div>
        <div>
            <h1 class="p-col-12 p-md-12 p-lg-6 float-left">
              <div class="float-left" style="margin-top: 12px">
                <span>
                  <a href @click.prevent="$router.back()" :title="$t('menu.back')" class="p-mr-2"><i class="pi pi-arrow-left" /></a>{{$t(title)}}
                </span>
              </div>
              <slot></slot>
            </h1>
            <div class="p-col-12 p-md-12 p-lg-6 float-left p-text-right" v-if="actions">
                <template v-for="(action, index) in actions">
                    <Button :key="index" class="p-button-outlined p-mr-2 p-mb-2" v-if="action.type === 'button'" @click.prevent="action.function()">
                        <i class="p-mr-2" :class="action.icon" /> {{$t(action.label)}}
                    </Button>
                    <router-link v-else :to="action.url" :key="index">
                        <Button :key="index" class="p-button-outlined p-mr-2 p-mb-2">
                            <i class="p-mr-2" :class="action.icon" /> {{$t(action.label)}}
                        </Button>
                    </router-link>
                </template>
            </div>
        </div>
        <hr style="width: 100%;"/>
    </div>
</template>

<script>
    export default {
        name: "PageHeader",
        props: {
            title: {type: String, default: null},
            actions: {type: Array, default: null}
        }
    }
</script>